




import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})

export default class PlusIcon extends Vue {
    @Prop() color: string;

    mounted() {
        if (this.color) {
            (this.$el as HTMLElement).style.setProperty('--plus-icon-background-color', this.color || 'white');
        }
    }
}

